import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useStyles } from "./SplitDowntimeCounters.styles";
import { getSplitStartDowntime, getSplitOriginalStartDowntime } from "../../utilities/storageUtilities";
import { formatCounter } from "utilities/utilities";

export const SplitDowntimeCounters = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const splitStart = getSplitStartDowntime();
    const originalStart = getSplitOriginalStartDowntime();
    const frozenCurrent = splitStart && originalStart ? splitStart - originalStart : 0;
    const [splitTime, setSplitTime] = useState(splitStart ? +new Date() - splitStart : 0);

    useEffect(() => {
        if (!splitStart) {
            return;
        }
        const interval = setInterval(() => {
            setSplitTime(+new Date() - splitStart);
        }, 10);
        return () => clearInterval(interval);
    }, [splitStart]);

    return (
        <Box className={classes.container}>
            <Box className={classes.counterBlock}>
                <Typography variant="subtitle2" className={classes.title}>
                    <p className={classes.titleText}>{t("HMI.current_downtime").toUpperCase()}</p>
                </Typography>
                <Box className={classes.clock}>
                    <Typography variant="h2">
                        <span>{formatCounter(frozenCurrent)}</span>
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.counterBlock}>
                <Typography variant="subtitle2" className={classes.title}>
                    <p className={classes.titleText}>{t("HMI.failure_details.split_downtime").toUpperCase()}</p>
                </Typography>
                <Box className={classes.clock}>
                    <Typography variant="h2">
                        <span>{formatCounter(splitTime)}</span>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
